import { bankNameValidator, emptyValidator, formValidator } from "../../validators";

const bankBranchValidationStatus = {
  brnName: {
    validators: [emptyValidator(), bankNameValidator()],
    name: "Branch Name",
  },
  brnBankReferance: {
    validators: [emptyValidator()],
    name: "Bank",
  },
};

export const bankBranchValidation = (bankBranch) => {
  return formValidator(bankBranch, bankBranchValidationStatus);
};
